module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/writable-browser.js
// module id = 1059
// module chunks = 0